// extracted by mini-css-extract-plugin
export var editButton = "_jg-0";